import { render, staticRenderFns } from "./SvTextarea.vue?vue&type=template&id=6a95c782&scoped=true&lang=pug&"
import script from "./SvTextarea.vue?vue&type=script&lang=js&"
export * from "./SvTextarea.vue?vue&type=script&lang=js&"
import style0 from "./SvTextarea.vue?vue&type=style&index=0&id=6a95c782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95c782",
  null
  
)

export default component.exports